import { useEffect, useState } from "react";
import Footer from "./small/Footer";
import { Icon } from "@iconify/react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useAuth } from "./firebase";
import { app } from "./firebase";
import { db, firestoredb } from "./firebase";
import { toast } from "react-toastify";
import { collection, addDoc, documentId } from "firebase/firestore";
import { updateProfile } from "firebase/auth";
import { storage, uploadImg } from "./firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { async } from "@firebase/util";
import { query, where, doc, getDocs, getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import {
  TOKEN_PROGRAM_ID,
  MINT_SIZE,
  createAssociatedTokenAccountInstruction,
  getAssociatedTokenAddress,
  createInitializeMintInstruction,
} from "@solana/spl-token";
import {
  Program,
  AnchorProvider,
  web3,
  utils,
  BN,
  setProvider,
} from "@project-serum/anchor";
import mint_nft from "../mint_nft.json";
import { Connection, PublicKey, clusterApiUrl } from "@solana/web3.js";
import { Buffer } from "buffer";
import { findMetadataPda } from "@metaplex-foundation/js";
import { createCreateMetadataAccountV2Instruction } from "@metaplex-foundation/mpl-token-metadata";
import FireStoreParser from "firestore-parser";

window.Buffer = Buffer;

const CreateNFT = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showlvl, setShowlvl] = useState(false);
  const handleLvlClose = () => setShowlvl(false);

  const [showstat, setShowstat] = useState(false);
  const handlestatClose = () => setShowstat(false);

  const currentUser = useAuth();
  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [blockchain, setBlockchain] = useState("solana");
  const [unlockable, setUnlockable] = useState(false);
  const [explicit, setExplicit] = useState(false);
  const [supply, setSupply] = useState("");
  const [selectedcollections, setSelectedCollection] = useState([]);
  const [collections, setCollection] = useState([]);
  const [photoURL, setPhotoURL] = useState("");
  const [description, setDescription] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const [walletAddress, setWalletKey] = useState("");
  const [properties, setProperties] = useState([]);
  const [propertyName, setPropertyName] = useState("");
  const [propertyVal, setPropertyVal] = useState("");
  const [documentID, setDocumentId] = useState("");
  const [jsonLink, setJsoinLink] = useState("");
  const [totalPropertySize, setTotalPropertySize] = useState(0);

  const [customProperties, setcustomProperties] = useState([
    { name: "test", val: "test" },
  ]);
  const programID = new PublicKey(mint_nft.metadata.address);
  const network = clusterApiUrl("devnet");
  const opts = {
    preflightCommitment: "processed",
    confirmTransactionInitialTimeout: 90000,
  };
  const { SystemProgram } = web3;

  const getProvider = () => {
    // const connection = new Connection(network, opts.preflightCommitment);
    var connection = new web3.Connection(clusterApiUrl("devnet"), {
      commitment: "confirmed",
      confirmTransactionInitialTimeout: 120000,
    });
    console.log(connection);
    const provider = new AnchorProvider(
      connection,
      window.solana,
      opts.preflightCommitment
    );
    return provider;
  };

  const addData = () => {
    setcustomProperties((prevState) => [...prevState, { name: "", val: "" }]);
    // const addprop = document.getElementById("addProperties");
    // const duplicate = addprop.cloneNode(true);
    // document.getElementById("allinpuits").appendChild(duplicate);
  };

  const handleImagechange = async (e) => {
    if (e.target.files[0]) {
      setLoadingState(true);
      setImage(e.target.files[0]);
      const imgURI = URL.createObjectURL(e.target.files[0]);
      setImageURL(imgURI);
      console.log(e.target.files[0]);
      // uploadImg(e.target.files[0], currentUser);

      const imageRef = ref(storage, currentUser?.uid + e.target.files[0].name);
      const snapshot = await uploadBytes(imageRef, e.target.files[0]);
      const imageLink = await getDownloadURL(imageRef);
      setPhotoURL(imageLink);

      setLoadingState(false);
      // document.getElementById("header-prof-pic").src = imgURI;
    }
  };

  function checkValidation() {
    var error = false;
    if (imageURL == null || imageURL == "") {
      toast("please select image", { toastId: "imageError" });
      error = true;
    }
    if (name == null || name == "") {
      toast("please put name", { toastId: "imageError1" });
      error = true;
    }
    if (description == null || description == "") {
      toast("please put description", { toastId: "imageError2" });
      error = true;
    }
    return error;
  }

  const handleSubmit = async () => {
    const mintKeypair = web3.Keypair.generate();
    console.log(checkValidation());
    // console.log(properties);
    if (checkValidation()) {
    } else {
      //   console.log("JSON", json.fields);

      var jsonString = JSON.stringify({
        walletAddress: walletAddress,
        name: name,
        symbol: "nice",
        image: photoURL,
        description: description,
        externalLinks: url,
        itemSupply: supply,
        collections: selectedcollections,
        unlockable: unlockable,
        explicit: explicit,
        blockchain: blockchain,
        timeStamp: Date.now(),
        mintAddress: mintKeypair.publicKey,
      });
      // create a Blob from the JSON-string
      var blob = new Blob([jsonString], { type: "application/json" });
      console.log("blob", blob);

      const jsonRef = ref(storage, name + Date.now() + ".json");
      const snapshot = await uploadBytes(jsonRef, blob);
      const jsonLink = await getDownloadURL(jsonRef)
        .then(async (downloadurl) => {
          console.log(downloadurl);
          //   setJsoinLink(downloadurl);
          await addDoc(collection(firestoredb, "metamuze_CreateNFT"), {
            walletAddress: walletAddress,
            jsonLink: downloadurl,
            listFlag: false,
          })
            .then((res) => {
              console.log(res.id);
              //   setDocumentId(res.id);

              Mint(downloadurl, mintKeypair);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const Mint = async (downloadurl, mintKeypair) => {
    try {
      console.log("Starting tasting ---->>>>>");
      const provider = getProvider();
      setProvider(provider);

      const proId = new PublicKey(mint_nft.metadata.address);
      const program = new Program(mint_nft, proId, provider);

      // const mintKeypair = web3.Keypair.generate();
      console.log(mintKeypair.toString());

      const testNftTitle = "Wallpaper786";
      const testNftSymbol = "Nice786";
      //   const testNftUri =
      //     "https://gateway.pinata.cloud/ipfs/QmSbn2eGLtFmjx69rjhPrJVKH1qAsAiZHeouVpqwFV9ouZ";
      const TOKEN_METADATA_PROGRAM_ID = new web3.PublicKey(
        "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
      );
      const SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID = new PublicKey(
        "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
      );

      const NftTokenAccount = await getAssociatedTokenAddress(
        mintKeypair.publicKey,
        provider.wallet.publicKey
      );
      console.log("NFT Account: ", NftTokenAccount.toBase58());

      console.log("Metadata");
      const getMetadata = (
        await web3.PublicKey.findProgramAddress(
          [
            Buffer.from("metadata"),
            TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            mintKeypair.publicKey.toBuffer(),
          ],
          TOKEN_METADATA_PROGRAM_ID
        )
      )[0];
      console.log("Metadata initialized", getMetadata);
      console.log("Minting Function", program.methods);
      console.log(TOKEN_PROGRAM_ID.toString());
      console.log(TOKEN_METADATA_PROGRAM_ID.toString());
      console.log(TOKEN_PROGRAM_ID.toString());
      console.log(photoURL);
      const tx = await program.methods
        .mint(name, testNftSymbol, downloadurl)
        .accounts({
          mintAuthority: provider.wallet.publicKey,
          mint: mintKeypair.publicKey,
          tokenAccount: NftTokenAccount,
          tokenProgram: TOKEN_PROGRAM_ID,
          metadata: getMetadata,
          tokenMetadataProgram: TOKEN_METADATA_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          rent: web3.SYSVAR_RENT_PUBKEY,
          associatedTokenProgram: SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID,
        })
        .signers([mintKeypair])
        .rpc();
      console.log("Your transaction signature", tx);
    } catch (err) {
      console.log(err);
    }
  };

  const getCollectionData = async () => {
    setLoadingState(true);

    console.log(walletAddress);
    const q = query(
      collection(firestoredb, "metamuze_CreateCollection"),
      where("walletAddress", "==", walletAddress)
    );
    const querySnapshot = await getDocs(q);

    console.log(walletAddress);

    setCollection([]);
    await querySnapshot.forEach((doc) => {
      let tempDocData = collections;
      tempDocData.push({ id: doc.id, docData: doc.data() });
      setCollection(tempDocData);
    });

    setLoadingState(false);
  };
  const walletListner = async () => {
    // console.log(window.solana);

    // @ts-ignore
    const { solana } = window;

    if (solana) {
      try {
        const response = await solana.connect();
        // console.log("wallet account ", response.publicKey.toString());
        // console.log(response.publicKey.toString());

        setWalletKey(response.publicKey.toString());
      } catch (err) {
        // { code: 4001, message: 'User rejected the request.' }
      }
    }
  };

  useEffect(() => {
    // getCollectionData();
    // console.log(collections);
    // console.log(walletAddress);

    walletListner();
  }, []);

  useEffect(() => {
    getCollectionData();
  }, [walletAddress]);

  return (
    <>
      {walletAddress ? (
        <>
          <Modal show={show} onHide={handleClose} className="prpmodal" centered>
            <Modal.Header>
              <div></div>
              <div className="modal-heading">
                <h1>Add Properties</h1>
              </div>
              <div>
                <Icon
                  icon="ic:baseline-cancel"
                  color="#dfc500"
                  width="32"
                  height="32"
                  onClick={handleClose}
                  className="baseline-cancel"
                />
              </div>
            </Modal.Header>
            <Modal.Body className="modal1">
              <p>
                Properties show up underneath your item, are clickable, and can
                be filtered in your collection's sidebar.
              </p>
              <div className="content-modal-head d-flex  ">
                <h4>Name</h4>
                <h4 style={{ marginLeft: "15rem" }}>Value</h4>
              </div>

              <div id="allinpuits">
                <div
                  id="addProperties"
                  className="d-flex flex-wrap align-items-center justify-content-between my-3"
                >
                  {customProperties && customProperties.length > 0 ? (
                    <>
                      {customProperties.map((item, index) => {
                        return (
                          <>
                            {" "}
                            <div className="modal-input-wrap">
                              <button
                                className="btn-closes"
                                onClick={() => {
                                  document
                                    .getElementById("addProperties")
                                    .remove();
                                }}
                              >
                                <Icon
                                  icon="akar-icons:cross"
                                  color="white"
                                  width="16"
                                  height="16"
                                />
                              </button>
                              <input
                                value={customProperties[index].name}
                                type="text"
                                placeholder="character"
                                onChange={(e) => {
                                  const newState = customProperties.map(
                                    (obj, i) => {
                                      // 👇️ if id equals 2, update country property

                                      return { ...obj, name: e.target.value };

                                      // 👇️ otherwise return object as is
                                    }
                                  );

                                  setcustomProperties(newState);
                                  // setPropertyName(e.target.value);
                                }}
                              />
                            </div>
                            <div className="modal-name-wrap">
                              <input
                                value={customProperties[index].val}
                                type="text"
                                placeholder="Male"
                                onChange={(e) => {
                                  const newState = customProperties.map(
                                    (obj, i) => {
                                      // 👇️ if id equals 2, update country property

                                      return { ...obj, val: e.target.value };

                                      // 👇️ otherwise return object as is
                                    }
                                  );

                                  setcustomProperties(newState);
                                }}
                              />
                            </div>
                          </>
                        );
                      })}
                    </>
                  ) : (
                    <>Test</>
                  )}
                </div>
              </div>
              <div className="addnewrow"></div>
              <button className="btn-addmore" onClick={addData}>
                Add more
              </button>
              <div>
                <button
                  className="btn-save"
                  onClick={(e) => {
                    console.log(propertyName);
                    console.log(propertyVal);

                    setProperties({
                      propertyName: propertyName,
                      propertyVal: propertyVal,
                    });

                    console.log(properties);
                  }}
                >
                  save
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showlvl}
            onHide={handleLvlClose}
            className="lvlmodal"
            centered
          >
            <Modal.Header>
              <div></div>
              <div className="modal-heading">
                <h1>Add Level</h1>
              </div>
              <div>
                <Icon
                  icon="ic:baseline-cancel"
                  color="#dfc500"
                  width="32"
                  height="32"
                  onClick={handleLvlClose}
                  className="baseline-cancel"
                />
              </div>
            </Modal.Header>
            <Modal.Body className=" modal1">
              <p>
                Properties show up underneath your item, are clickable, and can
                be filtered in your collection's sidebar.
              </p>

              <div className="content-modal-head d-flex  ">
                <h4>Name</h4>
                <h4 style={{ marginLeft: "12rem" }}>Value</h4>
              </div>
              <div className="d-flex align-items-center justify-content-between my-1">
                <div>
                  <div className="modal-input-wrap mt-3">
                    <button className="btn-closes">
                      <Icon
                        icon="akar-icons:cross"
                        color="white"
                        width="13"
                        height="13"
                      />
                    </button>
                    <input type="text" placeholder="character" />
                  </div>
                </div>

                <div>
                  <div className="d-flex mt-2">
                    <div className="modal-name-wrap mt-2">
                      <input type="number" placeholder="0" />
                    </div>
                    <div className="OF mt-2">Of</div>
                    <div className="modal-name-wrap brb mt-2">
                      <input type="number" placeholder="0" />
                    </div>
                  </div>
                </div>
              </div>

              <button className="btn-addmore">Add more</button>
              <div>
                <button className="btn-save">save</button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showstat}
            onHide={handlestatClose}
            className="lvlmodal"
            centered
          >
            <Modal.Header>
              <div></div>
              <div className="modal-heading">
                <h1>Add Stats</h1>
              </div>
              <div>
                <Icon
                  icon="ic:baseline-cancel"
                  color="#dfc500"
                  width="32"
                  height="32"
                  onClick={handlestatClose}
                  className="baseline-cancel"
                />
              </div>
            </Modal.Header>

            <Modal.Body className=" modal1">
              <p>
                Properties show up underneath your item, are clickable, and can
                be filtered in your collection's sidebar.
              </p>

              <div className="content-modal-head d-flex  ">
                <h4>Name</h4>
                <h4 style={{ marginLeft: "12rem" }}>Value</h4>
              </div>
              <div className="d-flex align-items-center justify-content-between my-1">
                <div>
                  <div className="modal-input-wrap mt-3">
                    <button className="btn-closes">
                      <Icon
                        icon="akar-icons:cross"
                        color="white"
                        width="13"
                        height="13"
                      />
                    </button>
                    <input type="text" placeholder="character" />
                  </div>
                </div>

                <div>
                  <div className="d-flex mt-2">
                    <div className="modal-name-wrap mt-2">
                      <input type="number" placeholder="0" />
                    </div>
                    <div className="OF mt-2">Of</div>
                    <div className="modal-name-wrap brb mt-2">
                      <input type="number" placeholder="0" />
                    </div>
                  </div>
                </div>
              </div>

              <button className="btn-addmore">Add more</button>
              <div>
                <button className="btn-save">save</button>
              </div>
            </Modal.Body>
          </Modal>

          <main className="create-own-bg">
            <section className="makeownbanner">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-sm-12">
                    <h3 className="createyourown">
                      Create
                      <span> Your </span> Own
                    </h3>
                  </div>
                </div>
              </div>
            </section>

            <section className="create-body">
              <div className="container">
                <div className="row">
                  <div className="col-sm-12">
                    <h3 className="craete-tit">
                      Image, Video, Audio, or 3d Model
                    </h3>
                    <p className="create-txt">
                      File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                      OGG, GLB, GLTF . Max size : 100MB
                    </p>
                  </div>
                </div>
              </div>
              <div className="container  nft-body">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <label>
                      {imageURL == null ? (
                        <img
                          className="img-picker"
                          src="../../assets/images/createyourown/chooseimg.png"
                          alt=""
                        />
                      ) : (
                        <img className="img-fluid" src={imageURL} alt="" />
                      )}

                      <input
                        type="file"
                        className="choose-a-file"
                        onChange={handleImagechange}
                      />
                    </label>
                  </div>
                  <div className="col-sm-8">
                    <div className="rigt-side-wrap">
                      <h3 className="craete-tit">Name :</h3>
                      <input
                        className="create-input-txt mt-2"
                        placeholder="Item Name"
                        type="text"
                        onChange={(e) => setName(e.target.value)}
                      />
                      <div className="spacer-create"></div>
                      <h3 className="craete-tit">External Links</h3>
                      <p className="create-txt">
                        Metamuze will include a link to this URl on this item’s
                        detail page, so that can click to learn more about it.
                        you are welcome to link to your own webpage with more
                        details.
                      </p>
                      <input
                        className="create-input-txt"
                        placeholder="Item Name"
                        type="url"
                        onChange={(e) => setUrl(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Image, Video, Audio, or 3d Model */}
                <div className="row">
                  <div className="col-sm-12">
                    <div className="text-area-section">
                      <h3 className="craete-tit">Description</h3>
                      <p className="create-txt">Add details about NFT</p>
                      <textarea
                        rows="4"
                        className="textareadescription"
                        placeholder="Provide a detailed description of your item."
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                {/* collection */}

                <div className="row">
                  <div className="col-sm-12">
                    <div className="text-area-section">
                      <h3 className="craete-tit">Collection</h3>
                      <p className="create-txt">
                        This is the collection where your item will appear.
                      </p>
                      {collections && collections.length > 0 ? (
                        <Form.Select
                          aria-label="Default select example"
                          onChange={(e) => {
                            setSelectedCollection(e.target.value);
                            console.log(e.target.value);
                          }}
                        >
                          <option>Open this select menu</option>
                          {collections && collections.length > 0 ? (
                            collections.map((item, index) => (
                              <option value={item.id} key={index}>
                                {item.docData.collectionName}
                              </option>
                            ))
                          ) : (
                            <></>
                          )}
                        </Form.Select>
                      ) : (
                        <>
                          <Link
                            className="create-collection-btn"
                            to="/createcollection"
                          >
                            Create Collection
                          </Link>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* for divider */}
                <div className="row">
                  <div className="col-sm-12">
                    <div className="divier-create-page"></div>
                  </div>
                </div>
                {/* divider ends */}
                {/* properties with modal*/}
                <div className="row">
                  <div className="col-sm-4">
                    <div className="prop-add">
                      <div>
                        <h3 className="craete-tit">
                          <Icon
                            className="ivon"
                            icon="heroicons-solid:menu-alt-1"
                          />
                          Properties
                        </h3>
                        <p className="create-txt prop-text">
                          Textual traits that show up as rectangies
                        </p>
                      </div>

                      <img
                        src="../../assets/images/createyourown/icoo.png"
                        alt=""
                        onClick={setShow}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="prop-add">
                      <div>
                        <h3 className="craete-tit">
                          <Icon
                            className="ivon"
                            icon="ant-design:star-filled"
                          />
                          Levels
                        </h3>
                        <p className="create-txt prop-text">
                          Textual traits that show up as rectangies
                        </p>
                      </div>

                      <img
                        src="../../assets/images/createyourown/icoo.png"
                        alt=""
                        onClick={setShowlvl}
                      />
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="prop-add">
                      <div>
                        <h3 className="craete-tit">
                          <Icon className="ivon" icon="gridicons:stats-alt-2" />
                          Stats
                        </h3>
                        <p className="create-txt prop-text">
                          Textual traits that show up as rectangies
                        </p>
                      </div>

                      <img
                        src="../../assets/images/createyourown/icoo.png"
                        alt=""
                        onClick={setShowstat}
                      />
                    </div>
                  </div>
                </div>

                {/* for divider */}
                <div className="row">
                  <div className="col-sm-12">
                    <div className="divier-create-page"></div>
                  </div>
                </div>
                {/* divider ends */}

                <div className="row align-items-center mt-5 unlockable">
                  <div className="col-sm-10 col-10">
                    <h3 className="craete-tit">
                      <Icon className="ivon" icon="bx:lock-open" />
                      Unlockable Content
                    </h3>
                    <p className="create-txt pt-2">
                      File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                      OGG, GLB, GLTF . Max size : 100MB
                    </p>
                  </div>

                  <div className="col-sm-2 col-2">
                    <div className="d-flex align-items-center justify-content-end">
                      <Form>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          onChange={(e) => {
                            setUnlockable(e.target.checked);
                          }}
                        />
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="row align-items-center mt-5 explicit">
                  <div className="col-sm-10 col-10">
                    <h3 className="craete-tit">
                      <Icon className="ivon" icon="jam:triangle-danger-f" />
                      Explicit & Sensitive Content
                    </h3>
                    <p className="create-txt pt-2">
                      Set this item as explicit and sensitive content
                    </p>
                  </div>

                  <div className="col-sm-2 col-2">
                    <div className="d-flex align-items-center justify-content-end">
                      <Form>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          onChange={(e) => {
                            setExplicit(e.target.checked);
                          }}
                        />
                      </Form>
                    </div>
                  </div>
                </div>

                {/* for divider */}
                <div className="row">
                  <div className="col-sm-12">
                    <div className="divier-create-page"></div>
                  </div>
                </div>
                {/* divider ends */}

                <div className="row align-items-end pt-4">
                  <div className="col-sm-6">
                    <h3 className="craete-tit">Supply</h3>
                    <p className="create-txt pt-2">
                      Set this item as explicit and sensitive content
                    </p>
                    <input
                      className="create-input-txt"
                      placeholder="Item Name"
                      type="text"
                      onChange={(e) => setSupply(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <h3 className="craete-tit pb-3 blockchainslect">
                      Blockchain
                    </h3>
                    <Form.Select
                      aria-label="Default select example"
                      onChange={(e) => setBlockchain(e.target.value)}
                    >
                      <option>Open this select menu</option>
                      <option value="solana">Solana</option>
                      <option value="etherium" disabled>
                        Etherium
                      </option>
                    </Form.Select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="text-area-section">
                      <h3 className="craete-tit">Collection</h3>
                      <p className="create-txt">
                        Freezing your metadata will allow you to permanently
                        lock and store all of this item's content in
                        decentralized file storage.
                      </p>
                      <div className="freeze">
                        To freeze your metadata, you must create your item
                        first.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <button className="createitembtn" onClick={handleSubmit}>
                      Create
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <Footer />
          </main>
        </>
      ) : (
        <>
          <section className="makeownbanner">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12">
                  <h3 className="createyourown">
                    Create
                    <span> Your </span> Own
                  </h3>
                </div>
              </div>
            </div>
          </section>
          <h3 className="connect-wallet-warnign">Please Connect Wallet</h3>
        </>
      )}
    </>
  );
};
export default CreateNFT;
